define("shared/components/shared/post/secondary/hashtag-suggestions/paid-upgrade-modal", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component"], function (_exports, _component, _templateFactory, _object, _service, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <section class="o--modalBody--secondary u--p__0 has--footer">
    {{! Upgrade }}
    <div class="cMH--blank">
      <Shared::Post::Secondary::HashtagSuggestions::UpgradeModalBackground />
      <div class="cMH--blank__overlay is--centered">
        <div class="u--p">
          <p class="u--text--bold u--text--md u--text--center u--m__b__xs">
            {{@upgradeTitle}}
          </p>
          <p class="u--text--light u--text--center u--m__b__0">
            {{@upgradeDescription}}
            {{#unless this.isMobileSubscription}}
              <Shared::Link
                @href={{@href}}
                @text={{t "shared_phrases.learn_more"}}
                title={{t "hashtag_suggestions.upsell.title"}}
              />
            {{/unless}}
          </p>
  
          {{#if this.isMobileSubscription}}
            <p class="u--text--center u--m__t__xs">
              <Shared::Ui::Button
                @class="u--p__0 u--text--hl"
                @text={{t "plans.mobile.learn_how"}}
                @variant="unstyled"
                onClick={{this.openMobileRedirectModal}}
              />
            </p>
          {{/if}}
        </div>
      </div>
    </div>
  </section>
  */
  {
    "id": "Q92m0Z+w",
    "block": "[[[10,\"section\"],[14,0,\"o--modalBody--secondary u--p__0 has--footer\"],[12],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"cMH--blank\"],[12],[1,\"\\n    \"],[8,[39,0],null,null,null],[1,\"\\n    \"],[10,0],[14,0,\"cMH--blank__overlay is--centered\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"u--p\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--text--bold u--text--md u--text--center u--m__b__xs\"],[12],[1,\"\\n          \"],[1,[30,1]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--text--light u--text--center u--m__b__0\"],[12],[1,\"\\n          \"],[1,[30,2]],[1,\"\\n\"],[41,[51,[30,0,[\"isMobileSubscription\"]]],[[[1,\"            \"],[8,[39,2],[[16,\"title\",[28,[37,3],[\"hashtag_suggestions.upsell.title\"],null]]],[[\"@href\",\"@text\"],[[30,3],[28,[37,3],[\"shared_phrases.learn_more\"],null]]],null],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"isMobileSubscription\"]],[[[1,\"          \"],[10,2],[14,0,\"u--text--center u--m__t__xs\"],[12],[1,\"\\n            \"],[8,[39,5],[[16,\"onClick\",[30,0,[\"openMobileRedirectModal\"]]]],[[\"@class\",\"@text\",\"@variant\"],[\"u--p__0 u--text--hl\",[28,[37,3],[\"plans.mobile.learn_how\"],null],\"unstyled\"]],null],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@upgradeTitle\",\"@upgradeDescription\",\"@href\"],false,[\"shared/post/secondary/hashtag-suggestions/upgrade-modal-background\",\"unless\",\"shared/link\",\"t\",\"if\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/post/secondary/hashtag-suggestions/paid-upgrade-modal.hbs",
    "isStrictMode": false
  });

  let PaidUpgradeModalComponent = (_class = class PaidUpgradeModalComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "subscriptions", _descriptor, this);
    }

    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }

    openMobileRedirectModal() {
      this.subscriptions.openMobileRedirectModal();
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "openMobileRedirectModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openMobileRedirectModal"), _class.prototype)), _class);
  _exports.default = PaidUpgradeModalComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PaidUpgradeModalComponent);
});